export default __webpack_public_path__ + "static/media/logo.41064a11.png";